export const blue = "#2484FF";
export const darkGray = "#2e2e2e";
export const white = "#fff";
